import { Grid, Typography } from "@mui/material";

import CoinDrawerSelect from "components/CoinDrawerSelect";
import DepositResult from "pages/Deposit/Component/DepositResult";
import DesktopDepositNetworks from "./Components/DesktopDepositNetworks";
import DesktopDepositTypes from "./Components/DesktopDepositTypes";
import PaymentGateway from "pages/Deposit/Component/PaymentGateway";
import { TYPES } from "pages/Deposit/constants";
import { useFormContext } from "react-hook-form";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

function DepositForm({
  selectedCoin,
  selectedCoinTypes,
  selectedCoinNetworks,
  coinList,
  isDigital,
}) {
  const navigate = useNavigate();
  const { watch } = useFormContext();

  const coin = watch("coin");
  const type = watch("type");
  const network = watch("network");

  const selectedWallet = useMemo(
    () =>
      coinList?.lisWallet?.find(
        (wallet) =>
          wallet?.coinId === coin &&
          wallet?.typeId === type &&
          wallet?.networkId === network
      ),
    [type, coin, network, coinList?.lisWallet]
  );

  return (
    <Grid container>
      <Typography variant="h4" color="text.main" marginBottom={3}>
        Select {isDigital ? "Coin" : "FIAT"}
      </Typography>

      <CoinDrawerSelect
        selectedCoin={selectedCoin}
        coinList={coinList}
        onCoinClick={(coin) => navigate(`/deposit/${coin?.id}`)}
      />

      <Typography
        variant="h4"
        fontWeight={600}
        color="text.main"
        marginTop={5}
        marginBottom={4}
      >
        Deposit to
      </Typography>

      <DesktopDepositTypes selectedCoinTypes={selectedCoinTypes} />

      {type === TYPES.paymentGateway ? (
        <PaymentGateway selectedWallet={selectedWallet} />
      ) : (
        <>
          {selectedCoinNetworks?.length > 1 && (
            <DesktopDepositNetworks
              selectedCoinNetworks={selectedCoinNetworks}
            />
          )}

          <DepositResult
            selectedWallet={selectedWallet}
            selectedCoin={selectedCoin}
          />
        </>
      )}
    </Grid>
  );
}

export default DepositForm;
